var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, AvatarGroup, Badge, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, BlushBrush02Icon, DocumentAttachmentIcon, MessageDownload01Icon, MoreVerticalCircle01Icon } from 'hugeicons-react';
import { MessageQuestion } from 'iconsax-reactjs';
import { Fragment, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useExportChatMutation } from '../../../../../application/features/chat-download/chat-download-api';
import { useClearChatMutation, useGetConversationsQuery } from '../../../../../application/features/chat/chat-api';
import { useLazyGetMachineDocumentListByIdsQuery } from '../../../../../application/features/machine-documents/machine-document-api';
import { useLazyGetMatchingTechniciansQuery } from '../../../../../application/features/technicians/technician-api';
import { useAppSelector } from '../../../../../application/store/useStore';
import useTranslate from '../../../../../localization/helpers';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import FindMachine from '../../../../components/FindMachine';
import AiUserIcon from '../../../../icons/components/ai-user';
import ViewDocument from '../../../knowledge/view-document';
import ChatHistoryDrawer from './chat-history-drawer';
import ChatFaqs from './ChatFaqs';
import ChatPDF from './ChatPDF';
import RecentTechnicianDrawer from './recent-technician-drawer';
import './style.scss';
var ChatHeader = function (_a) {
    var _b, _c;
    var _d, _e, _f, _g, _h;
    var conversationId = _a.conversationId, documents = _a.documents, userId = _a.userId, toggleAccordion = _a.toggleAccordion, isAccordionExpanded = _a.isAccordionExpanded, _j = _a.messages, messages = _j === void 0 ? [] : _j, faqs = _a.faqs, openDrawer = _a.openDrawer, _k = _a.isExpanded, isExpanded = _k === void 0 ? false : _k;
    var MACHINE_ENDPOINT = process.env.REACT_APP_CHAT_MACHINE_ENDPOINT;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var _l = __read(useState(false), 2), faqsDrawerOpen = _l[0], setFaqsDrawerOpen = _l[1];
    var contentRef = useRef(null);
    var _m = __read(useState(isAccordionExpanded), 2), accordionOpen = _m[0], setAccordionOpen = _m[1];
    var accordionRef = useRef(null);
    var _o = __read(useState(false), 2), downloadChatOpen = _o[0], setDownloadChatOpen = _o[1];
    var _p = __read(useState(false), 2), recentTechnicianDrawerOpen = _p[0], setRecentTechnicianDrawerOpen = _p[1];
    var _q = __read(useState(false), 2), isChatHistoryDrawerOpen = _q[0], setIsChatHistoryDrawerOpen = _q[1];
    var _r = __read(useState(false), 2), findMachineModalOpen = _r[0], setFindMachineModalOpen = _r[1];
    var _s = __read(useState(null), 2), chatActionsAnchorEl = _s[0], setChatActionsAnchorEl = _s[1];
    var _t = __read(useState(false), 2), clearChatConfirmOpen = _t[0], setClearChatConfirmOpen = _t[1];
    var _u = useAppSelector(function (state) { return state.common; }), chatMachineStatus = _u.chatMachineStatus, chatApiStatus = _u.chatApiStatus;
    var handleOpenDrawer = function () {
        setRecentTechnicianDrawerOpen(true);
    };
    var apiStatus = MACHINE_ENDPOINT
        ? chatMachineStatus === 'off'
            ? 'error'
            : chatMachineStatus === 'starting' || chatApiStatus === 'off'
                ? 'warning'
                : 'success'
        : 'success';
    var _v = __read(useState({ isOpen: false }), 2), viewDocument = _v[0], setViewDocument = _v[1];
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _w = __read(useLazyGetMachineDocumentListByIdsQuery(), 2), getDocumentDetails = _w[0], _x = _w[1], _y = _x.data, documentDetails = _y === void 0 ? [] : _y, documentDetailsLoading = _x.isLoading;
    var _z = __read(useLazyGetMatchingTechniciansQuery(), 2), getMatchingTechnicians = _z[0], _0 = _z[1].data, matchingTechnicians = _0 === void 0 ? [] : _0;
    var _1 = __read(useClearChatMutation(), 2), triggerClearChat = _1[0], isLoadingClearChat = _1[1].isLoading;
    var _2 = useGetConversationsQuery(currentUser.userId).data, conversations = _2 === void 0 ? [] : _2;
    var _3 = __read(useExportChatMutation(), 2), downloadChat = _3[0], downloadChatLoading = _3[1].isLoading;
    var currentConversation = (_d = conversations.find(function (conversation) { return conversation.conversation_id === conversationId; })) === null || _d === void 0 ? void 0 : _d.conversation_name;
    var downloadChatDisabled = messages.length === 0 || documentDetailsLoading || downloadChatLoading;
    useEffect(function () {
        if (documents.length) {
            var documentIds = documents.map(function (document) { return document.document_id; });
            getDocumentDetails({ machineDocumentIds: documentIds });
            getMatchingTechnicians({ machineDocuments: documentIds });
        }
    }, [documents, getDocumentDetails, getMatchingTechnicians]);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (accordionRef.current && !accordionRef.current.contains(event.target)) {
                setAccordionOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var chatActions = __spreadArray([
        {
            id: 0,
            title: translate('common.faqs'),
            disabled: !faqs.length || (!!faqs.length && !faqs[0].id),
            icon: (_jsx(MessageQuestion, { color: !faqs.length || (!!faqs.length && !faqs[0].id)
                    ? undefined
                    : theme.palette.secondary.main })),
            action: function (e) {
                e.stopPropagation();
                setFaqsDrawerOpen(true);
            }
        },
        {
            id: 1,
            title: translate('common.documents'),
            icon: _jsx(DocumentAttachmentIcon, { color: theme.palette.primary.main }),
            action: function () { return toggleAccordion(); }
        },
        {
            id: 2,
            title: translate('chat.clearChat'),
            icon: _jsx(BlushBrush02Icon, { color: theme.palette.error.main }),
            action: function (e) {
                e.stopPropagation();
                setClearChatConfirmOpen(true);
            },
            itemColor: theme.palette.error.main,
            disabled: !(messages && messages.length > 0)
        },
        {
            id: 3,
            title: translate('chat.downloadChat'),
            icon: _jsx(MessageDownload01Icon, {}),
            action: function (e) {
                e.stopPropagation();
                downloadChatPdf();
            },
            itemColor: theme.palette.text.primary,
            disabled: downloadChatDisabled
        }
    ], __read((matchingTechnicians && matchingTechnicians.length > 0
        ? [
            {
                id: 4,
                title: translate('chat.recentTechnicians'),
                icon: _jsx(AiUserIcon, {}),
                action: function (e) {
                    e.stopPropagation();
                    handleOpenDrawer();
                },
                itemColor: theme.palette.text.primary
            }
        ]
        : [])), false);
    var onViewDocument = function (document) {
        return setViewDocument({ isOpen: true, document: document });
    };
    var handleClearChat = function () {
        setClearChatConfirmOpen(false);
        triggerClearChat({ userId: userId, conversationId: conversationId });
    };
    var openChatActions = function (event) {
        event.stopPropagation();
        setChatActionsAnchorEl(event.currentTarget);
    };
    var closeChatActions = function (event) {
        event.stopPropagation();
        setChatActionsAnchorEl(null);
    };
    var downloadChatPdf = function () {
        setDownloadChatOpen(true);
        setTimeout(function () {
            exportChatPdf();
        }, 300);
    };
    var menuOpen = Boolean(chatActionsAnchorEl);
    var exportChatPdf = useReactToPrint({
        contentRef: contentRef,
        ignoreGlobalStyles: true,
        pageStyle: "@media print {\n                    @page {\n                        size: legal portrait;\n                         @bottom-right {\n                            content: \"Page \" counter(page) \" of \" counter(pages);\n                            font-size: 10px;\n                          }\n                      }\n                  }",
        print: function (printIframe) { return __awaiter(void 0, void 0, void 0, function () {
            var document, html;
            return __generator(this, function (_a) {
                setDownloadChatOpen(false);
                document = printIframe.contentDocument;
                if (document) {
                    html = document.getElementsByTagName('html');
                    downloadChat({ htmlContent: html[0].innerHTML });
                }
                return [2 /*return*/];
            });
        }); }
    });
    return (_jsxs(Fragment, { children: [_jsxs(Accordion, { expanded: accordionOpen, ref: accordionRef, onChange: function (e, expanded) {
                    if (!menuOpen || menuOpen) {
                        e.stopPropagation();
                        setAccordionOpen(expanded);
                    }
                }, sx: {
                    position: 'absolute',
                    width: '100%',
                    zIndex: 1,
                    boxShadow: 'none'
                }, disableGutters: true, children: [_jsx(AccordionSummary, { "aria-controls": 'panel1a-content', id: 'panel1a-header', sx: (_b = {
                                width: '100%',
                                pointerEvents: 'none',
                                backgroundColor: 'white',
                                '.MuiAccordionSummary-content': {
                                    my: { md: 1.5, xs: 0.5 },
                                    width: '100%'
                                }
                            },
                            _b[theme.breakpoints.down('sm')] = {
                                width: '100%',
                                '.MuiAccordionSummary-content': {
                                    width: '100%'
                                }
                            },
                            _b), onClick: function (e) { return e.stopPropagation(); }, children: _jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', children: [_jsxs(Box, { display: 'flex', gap: '10px', sx: {
                                        width: '100%',
                                        overflow: 'hidden'
                                    }, children: [!isXs && !isExpanded && (_jsx(IconButton, { component: 'div', size: 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                openDrawer();
                                                e.stopPropagation();
                                            }, children: _jsx(Icon, { icon: 'solar:clock-circle-linear' }) })), ((_e = documentDetails[0]) === null || _e === void 0 ? void 0 : _e.machineName) && (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%', sx: (_c = {},
                                                _c[theme.breakpoints.down('sm')] = {
                                                    width: '100%',
                                                    flex: '1 1 auto'
                                                },
                                                _c), children: [_jsx(Typography, { variant: 'h6', fontWeight: 500, sx: {
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        width: '100%'
                                                    }, children: (_f = documentDetails[0]) === null || _f === void 0 ? void 0 : _f.machineName }), _jsx(Typography, { variant: 'caption', color: 'text.secondary', sx: {
                                                        whiteSpace: 'nowrap',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        width: '100%'
                                                    }, children: currentConversation })] }))] }), _jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', children: isExpanded ? (_jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', children: [!isExpanded && (_jsxs(Box, { display: 'flex', flexDirection: 'row', position: 'relative', children: [_jsx(IconButton, { component: 'div', color: 'primary', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                            e.stopPropagation();
                                                            setFindMachineModalOpen(true);
                                                        }, children: _jsx(Add01Icon, {}) }), _jsx(Badge, { variant: 'dot', color: apiStatus, sx: { '& .MuiBadge-badge': { height: '5px', minWidth: '5px' } }, className: chatMachineStatus === 'starting' || chatApiStatus === 'off'
                                                            ? 'blinking-badge'
                                                            : 'not-blinking-badge' })] })), _jsx(IconButton, { component: 'div', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                    e.stopPropagation();
                                                    setIsChatHistoryDrawerOpen(true);
                                                }, children: _jsx(Icon, { icon: 'solar:clock-circle-linear' }) }), _jsx(IconButton, { component: 'div', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                    toggleAccordion();
                                                }, children: _jsx(DocumentAttachmentIcon, { color: theme.palette.primary.main }) }), _jsx(IconButton, { component: 'div', sx: { pointerEvents: 'auto' }, size: isXs ? 'Xs' : 'medium', onClick: function (e) {
                                                    e.stopPropagation();
                                                    openChatActions(e);
                                                }, children: _jsx(MoreVerticalCircle01Icon, {}) }), _jsx(Menu, { anchorEl: chatActionsAnchorEl, open: menuOpen, onClose: closeChatActions, children: chatActions
                                                    .filter(function (item) { return item.id !== 1; })
                                                    .map(function (item) {
                                                    var isLoadingForItem = item.id === 3 && isLoadingClearChat;
                                                    return (_jsxs(MenuItem, { onClick: function (event) {
                                                            closeChatActions(event);
                                                            if (item.action) {
                                                                item.action(event);
                                                            }
                                                        }, sx: { color: item.itemColor }, disabled: isLoadingForItem || item.disabled, children: [_jsx(ListItemIcon, { children: item.icon }), _jsx(ListItemText, { primary: item.title })] }, item.id));
                                                }) })] })) : !isXs && !isscreen600900Landscape ? (_jsxs(Stack, { direction: 'row', gap: 1, children: [matchingTechnicians && matchingTechnicians.length > 0 && (_jsx(AvatarGroup, { max: 3, onClick: function (e) {
                                                    e.stopPropagation();
                                                    handleOpenDrawer();
                                                }, sx: {
                                                    cursor: 'pointer',
                                                    pointerEvents: 'auto',
                                                    '& .MuiAvatar-root': { width: 35, height: 35, fontSize: 15 }
                                                }, children: matchingTechnicians.map(function (technician) { return (_jsx(Avatar, { alt: technician.fullName, src: technician.fullName }, technician.id)); }) })), _jsx(Box, { sx: {
                                                    display: 'flex',
                                                    gap: 0.5,
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.background.neutral
                                                }, children: chatActions
                                                    .filter(function (item) { return item.id === 0 || item.id === 1; })
                                                    .map(function (item) { return (_jsx(IconButton, { component: 'div', onClick: function (e) { var _a; return (_a = item.action) === null || _a === void 0 ? void 0 : _a.call(item, e); }, sx: { color: item.itemColor, pointerEvents: 'auto' }, disabled: item.disabled, children: item.icon }, item.id)); }) }), _jsx(Box, { sx: {
                                                    display: 'flex',
                                                    gap: 0.5,
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.background.neutral
                                                }, children: chatActions
                                                    .filter(function (item) { return item.id === 2 || item.id === 3; })
                                                    .map(function (item) {
                                                    var isLoadingForItem = item.id === 3 && isLoadingClearChat;
                                                    return (_jsx(IconButton, { component: 'div', onClick: function (e) { var _a; return (_a = item.action) === null || _a === void 0 ? void 0 : _a.call(item, e); }, sx: { color: item.itemColor, pointerEvents: 'auto' }, disabled: isLoadingForItem || item.disabled, children: item.icon }, item.id));
                                                }) })] })) : (_jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', children: [!isExpanded && (_jsxs(Box, { display: 'flex', flexDirection: 'row', position: 'relative', children: [_jsx(IconButton, { component: 'div', color: 'primary', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                            e.stopPropagation();
                                                            setFindMachineModalOpen(true);
                                                        }, children: _jsx(Add01Icon, {}) }), _jsx(Badge, { variant: 'dot', color: apiStatus, sx: { '& .MuiBadge-badge': { height: '5px', minWidth: '5px' } }, className: chatMachineStatus === 'starting' || chatApiStatus === 'off'
                                                            ? 'blinking-badge'
                                                            : 'not-blinking-badge' })] })), _jsx(IconButton, { component: 'div', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                    e.stopPropagation();
                                                    setIsChatHistoryDrawerOpen(true);
                                                }, children: _jsx(Icon, { icon: 'solar:clock-circle-linear' }) }), _jsx(IconButton, { component: 'div', size: isXs ? 'Xs' : 'medium', sx: { pointerEvents: 'auto' }, onClick: function (e) {
                                                    toggleAccordion();
                                                }, children: _jsx(DocumentAttachmentIcon, { color: theme.palette.primary.main }) }), _jsx(IconButton, { component: 'div', sx: { pointerEvents: 'auto' }, size: isXs ? 'Xs' : 'medium', onClick: function (e) {
                                                    e.stopPropagation();
                                                    openChatActions(e);
                                                }, children: _jsx(MoreVerticalCircle01Icon, {}) }), _jsx(Menu, { anchorEl: chatActionsAnchorEl, open: menuOpen, onClose: closeChatActions, children: chatActions
                                                    .filter(function (item) { return item.id !== 1; })
                                                    .map(function (item) {
                                                    var isLoadingForItem = item.id === 3 && isLoadingClearChat;
                                                    return (_jsxs(MenuItem, { onClick: function (event) {
                                                            closeChatActions(event);
                                                            if (item.action) {
                                                                item.action(event);
                                                            }
                                                        }, sx: { color: item.itemColor }, disabled: isLoadingForItem || item.disabled, children: [_jsx(ListItemIcon, { children: item.icon }), _jsx(ListItemText, { primary: item.title })] }, item.id));
                                                }) })] })) })] }) }), _jsx(AccordionDetails, { sx: {
                            backgroundColor: 'white',
                            maxHeight: isscreen600900Landscape ? '100px' : '400px',
                            overflow: 'auto',
                            borderRadius: 2
                        }, children: documentDetails.map(function (document) { return (_jsx(Box, { padding: '16px', width: '100%', boxShadow: '0 10px 48px 0 #919EAB29', display: 'flex', borderRadius: '12px', sx: { cursor: 'pointer' }, onClick: function () { return onViewDocument(document); }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', width: '100%', gap: 0.5, children: [_jsx(Typography, { variant: 'subtitle2', sx: { wordBreak: 'break-all' }, children: document.title }), _jsx(Box, { display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', children: document.fileName }) }), _jsx(Tooltip, { title: document.aiSummary, arrow: true, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', sx: {
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }, children: document.aiSummary }) })] }) }, document.id)); }) })] }), _jsx(ChatHistoryDrawer, { isOpen: isChatHistoryDrawerOpen, setIsOpen: setIsChatHistoryDrawerOpen }), _jsx(FindMachine, { isOpen: findMachineModalOpen, setIsOpen: setFindMachineModalOpen }), matchingTechnicians && (_jsx(RecentTechnicianDrawer, { matchingTechnicians: matchingTechnicians, isRecentTechnicianDrawerOpen: recentTechnicianDrawerOpen, setRecentTechnicianDrawerOpen: setRecentTechnicianDrawerOpen })), clearChatConfirmOpen && (_jsx(ConfirmDialog, { title: translate('chat.clearChat'), closeButtonText: translate('actions.cancel'), confirmButtonText: translate('actions.confirm'), content: translate('chat.clearChatText'), onClose: function () { return setClearChatConfirmOpen(false); }, onConfirm: handleClearChat, open: clearChatConfirmOpen, mode: 'warning' })), viewDocument.document && (_jsx(ViewDocument, { documentId: viewDocument.document.id, filePath: viewDocument.document.filePath, title: viewDocument.document.title, open: viewDocument.isOpen, onClose: function () { return setViewDocument({ isOpen: false }); } })), downloadChatOpen && (_jsx("div", { style: { display: 'none' }, children: _jsx("div", { ref: contentRef, children: _jsx(ChatPDF, { documents: documentDetails, messages: messages, conversationName: currentConversation, userName: currentUser.name, machineName: (_h = (_g = documentDetails[0]) === null || _g === void 0 ? void 0 : _g.machineName) !== null && _h !== void 0 ? _h : '' }) }) })), faqsDrawerOpen && (_jsx(ChatFaqs, { isOpen: faqsDrawerOpen, onClose: function () { return setFaqsDrawerOpen(false); }, faqs: faqs }))] }));
};
export default ChatHeader;
